import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';

export const PanelPersonalMenu = {
    computed: {
        ...mapState(vplSiteStore, ['menu', 'IS_AUTHORIZED'])
    },
    mounted(){

    },
    methods: {
        personalClick(e){

            if(!this.IS_AUTHORIZED){
                e.preventDefault();
                e.stopPropagation();
                $('#entrance').modal();
            }
        }
    },
    template: `
            <template v-if="this.menu.personal">
                <a v-for="menuItem in this.menu.personal.ITEMS" :key="menuItem.TEXT" :href="menuItem.LINK" @click="personalClick($event)" class="panel__item">
                    <span class="panel__item-ico">
                        <svg class="icon icon-lk"><use xlink:href="#icon-lk"></use></svg>
                    </span>
                    <span>{{menuItem.TEXT}}</span>
                </a>
            </template>
    `
}